import { render, staticRenderFns } from "./newAddres.vue?vue&type=template&id=aaa4c112&scoped=true&"
import script from "./newAddres.vue?vue&type=script&lang=js&"
export * from "./newAddres.vue?vue&type=script&lang=js&"
import style0 from "./newAddres.vue?vue&type=style&index=0&id=aaa4c112&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa4c112",
  null
  
)

export default component.exports